import { ReactElement } from 'react'

type VisibleProps = {
  when: boolean
  children: ReactElement
  fallback?: ReactElement
}

export const Visible = ({ when, children, fallback = null }: VisibleProps) => (when ? children : fallback)
